import { PageContainer, ProTable } from '@ant-design/pro-components';
import { useMutation } from '@tanstack/react-query';
import { App, Button } from 'antd';
import { useRef } from 'react';
import { querySkills, updateSkillRegistry } from '../services/skills';

const columns = [
  {
    title: '技能名称',
    dataIndex: 'name',
    copyable: true,
  },
  {
    title: '能力说明',
    dataIndex: 'description',
    search: false,
  },
  {
    title: '版本',
    dataIndex: 'version',
    search: false,
  },
];

const Skills = () => {
  const actionRef = useRef(null);
  const { message } = App.useApp();
  const { mutateAsync: refreshRegistry, isPending } = useMutation({
    mutationFn: updateSkillRegistry,
    onSuccess: () => {
      actionRef.current?.reload?.();
      message.success('技能 Registry 已更新');
    },
    onError: () => {
      message.error('技能 Registry 更新失败，请重试');
    },
  });

  return (
    <PageContainer content="厂商管理员在这里查看执行容器可调用的 Schema Skill，并更新 Skill Registry。">
      <ProTable
        actionRef={actionRef}
        rowKey="name"
        headerTitle="技能列表"
        request={querySkills}
        columns={columns}
        search={false}
        toolBarRender={() => [
          <Button
            key="refresh"
            type="primary"
            loading={isPending}
            onClick={() => refreshRegistry()}
          >
            更新 Registry
          </Button>,
        ]}
      />
    </PageContainer>
  );
};

export default Skills;
